import { ApplicationRef, Inject, Injectable, NgModule } from '@angular/core';
import { ROUTED_ENTITY_ALTERNATIVES } from '@nx-icilalune/data/icilalune/tokens';
import { map, Observable } from 'rxjs';
import { TranslationItem } from '@nx-icilalune/drupal-types';
import { ComponentStore } from '@ngrx/component-store';
import { Dialog } from '@angular/cdk/dialog';
import { CommonModule, DOCUMENT } from '@angular/common';
import {
  LanguageSwitcherComponent,
  LanguageSwitcherResult,
} from './language-switcher.component';

interface LanguageState {
  translationItems?: TranslationItem[];
}

@Injectable()
export class LanguageService extends ComponentStore<LanguageState> {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(ROUTED_ENTITY_ALTERNATIVES)
    private contentAlternatives$: Observable<TranslationItem[]>,
    private dialog: Dialog,
    private appRef: ApplicationRef
  ) {
    super({});
    this.patchState(
      this.contentAlternatives$.pipe(
        map((contentAlternatives) => {
          return { translationItems: contentAlternatives };
        })
      )
    );
  }

  switch() {
    const translationItems = this.get((s) => s.translationItems);
    if (translationItems && translationItems.length > 0) {
      const translationItem = translationItems[0];
      if (translationItem) {
        const switcherRef = this.dialog.open<LanguageSwitcherResult>(
          LanguageSwitcherComponent,
          {
            panelClass: 'language-switcher',
            disableClose: true,
          }
        );
        switcherRef.closed.subscribe((result) => {
          if (result === 'switch') {
            if (this.document.defaultView) {
              const origin = this.document.defaultView.location.origin;
              const path = `${origin}${translationItem.path ?? ''}`;
              this.document.defaultView.location.href = `${origin}${
                translationItem.path ?? ''
              }`;
            }
          }
        });
        this.appRef.tick();
      }
    }
  }
}

@NgModule({
  imports: [CommonModule],
  providers: [LanguageService],
})
export class IcilaluneLanguageModule {}
